import { Keyword, List, Shadow } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
const { either } = Parser;
const parseList = List.parseCommaSeparated(Shadow.parse());
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/box-shadow}
 * @internal
 */
export default Longhand.of(Keyword.of("none"), either(Keyword.parse("none"), parseList), (value, style) => value.resolve(Resolver.length(style)));
//# sourceMappingURL=box-shadow.js.map